// @flow
import debounce from "lodash/debounce";

import { updateForm } from "../_modularui/ModularUIActions";

import ModularUIRequest from "../../modularui/ModularUIRequest";

import {
  HTTP_METHODS,
  VALIDATE_DEBOUNCE_TIMEOUT,
} from "../../constants/Constants";

import FormModel from "../../models/form/FormModel";

import type { Dispatch, GetState, ThunkAction } from "../types";
import type { ModularUIModel } from "../../models";

/**
 * Update validations of the form currently in the reducer
 * because of the debounce timeout there might have been an update on the form during validation
 */
const updateValidations =
  (form: FormModel, formWithValidations: ModularUIModel) =>
  (dispatch: Dispatch, getState: GetState) => {
    const currentForm = getState().modularui[form.connectKey];

    if (currentForm) {
      const validatedForm = currentForm.model.clone();
      if (validatedForm instanceof FormModel) {
        validatedForm.updateValidations(
          formWithValidations.data,
          form.currentFormObject,
        );
      }

      dispatch(updateForm(validatedForm));
    }
  };

/**
 * Validates form objects debounced to prevent overloading the (form) service
 * When a form with new errors (or complete) arrives, we send the validations
 * to the current form model where the errors are processed
 * A new form with the new constraints is send to the store
 */
const debouncedValidateFormObject = debounce<
  (dispatch: Dispatch, form: FormModel) => void,
>(
  (dispatch, form: FormModel) => {
    new ModularUIRequest(form.selfhref.setParameter("commit", "false"), {
      method: HTTP_METHODS.POST,
      data: form.validationData,
      childmodels: false,
      isValidationRequest: true,
      locale: form.locale,
    })
      .fetch()
      .then((formWithValidations) =>
        dispatch(updateValidations(form, formWithValidations)),
      );
  },
  VALIDATE_DEBOUNCE_TIMEOUT,
  {
    leading: true,
    trailing: true,
  },
);

/**
 */
export const validateFormObject =
  (form: FormModel): ThunkAction<> =>
  (dispatch) =>
    debouncedValidateFormObject(dispatch, form);
